// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"af719e42","620":"58efebcd","773":"cf54f360","871":"afbae0bc"}[chunkId] + ".chunk.css";
};